import styled from "styled-components";

export default styled.div`
  min-height: 138px;
  height: auto;
  max-width: 120px;
  width: 100%;
  transition: all 0.3s ease-in-out;
  ${({ checked }) => checked && `
    filter: drop-shadow(0px 0px 28px rgba(78, 100, 236, 0.5));
  `}
  > label {
    min-height: 138px;
    height: auto;
    max-width: 120px;
    width: 100%;
    position: relative;
    display: flex;
    align-items: end;
  }
  .checkbox-duration-container {
    display: block;
    label {
      position: relative;
      cursor: pointer;
      display: flex;
      align-items: center;
      span {
        padding-top: 2px;
        font-style: normal;
        font-weight: 400;
        font-size: 10px;
        line-height: 15px;
        display: flex;
        align-items: center;
        color: #6d7d97;
      }
      :before {
        content: "";
        -webkit-appearance: none;
        background-color: transparent;
        border: 1px solid #6d7d97;
        border-radius: 50%;
        padding: 5px;
        display: inline-block;
        position: relative;
        vertical-align: middle;
        cursor: pointer;
        margin-right: 5px;
      }
    }
    input {
      padding: 0;
      height: initial;
      width: initial;
      margin-bottom: 0;
      display: none;
      cursor: pointer;
    }
    input:checked + label:after {
      content: "";
      display: block;
      position: absolute;
      left: 3px;
      margin-top: 0.5px;
      width: 6px;
      height: 6px;
      background: #0d6bbd;
      border-radius: 100%;
    }
    input:checked + label:before {
      background-color: transparent;
      border-color: #0d6bbd;
    }
  }

  :nth-of-type(1) {
    .percent-rectangle {
      background-color: ${({ theme }) => theme.colors.ellipse_8};
    }
  }
  :nth-of-type(2) {
    .percent-rectangle {
      background-color: ${({ theme }) => theme.colors.ellipse_9};
    }
  }
  :nth-of-type(3) {
    .percent-rectangle {
      background-color: ${({ theme }) => theme.colors.ellipse_10};
    }
  }
  :nth-of-type(4) {
    .percent-rectangle {
      background-color: ${({ theme }) => theme.colors.ellipse_11};
    }
  }

  .percent-rectangle {
    z-index: 1;
    position: absolute;
    width: 86px;
    height: 103px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    border-radius: 10px;

    .circle {
      position: relative;
      padding: 0;
      font-size: 14px;
      line-height: 1;
      list-style: none;
      font-feature-settings: "tnum";
      display: inline-block;

      .inner {
        position: relative;
        width: 80px;
        height: 80px;
        display: inline-block;
        overflow: hidden;
        vertical-align: middle;

        border-radius: 100px;
        background-color: transparent;
        font-size: 24px;
        line-height: 1;

        svg {
          width: 100%;
          height: 100%;
        }

        circle,
        .path {
          stroke-width: 6px;
          stroke: rgba(255, 255, 255, 0.5);
        }

        .active {
          stroke: #ffffff;
          stroke-width: 7px;
          stroke-linecap: round;
          stroke-dasharray: ${(props) => (295 * props.percent) / 100}, 295;
          stroke-dashoffset: 0;
          animation: dash 0.4s ease-out;
          animation-fill-mode: forwards;
        }
      }
      .text {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-weight: 600;
        font-size: 24.8327px;
        line-height: 28px;

        display: flex;
        align-items: center;
        letter-spacing: -0.035em;

        color: #ffffff;
        small {
          font-size: 15.5615px;
        }
      }
    }

    @keyframes dash {
      from {
        stroke-dasharray: 0, 999;
      }
    }
  }
  .footer-rectangle {
    position: relative;
    width: 100%;
    height: 76px;
    background: ${({ theme }) => theme.colors.ellipse_12};
    border-radius: 0px 0px 10px 10px;
    display: flex;
    padding: 9px 0;
    align-items: end;
    justify-content: center;
    .rocket-container {
      position: absolute;
      z-index: 2;
      top: 30px;
      right: 30px;
      width: 20px;
      height: 20px;
      display: grid;
      place-items: center;
      background: #38a0ff;
      border-radius: 7.06889px 7.06889px 7.06889px 0px;
      img {
        user-select: none;
        width: 12px;
        height: 12px;
      }
    }
  }
  @media (max-width: 797px) {
    flex: 1 1 170px;
    max-width: unset;
    width: unset;
    display: flex;
    justify-content: center;
  }
`;
